module.exports = __webpack_public_path__ + "img/33.9.TU.0223ca7d.png";